import _ from "lodash";
import { Text, Title, Divider, Group, ThemeIcon, Badge, Table } from "@mantine/core";
import React, { useState, useEffect } from "react";
import moment from "moment";
import InfoGridList from "./infoGridList";
import { useCellRender } from "../hooks/useCellRender";
import { useServerApi } from "../hooks/userServerApi";

import { IconClick, IconCash, IconHeart } from "@tabler/icons";
import { useTranslation } from "react-i18next";

export default function ClientBasicInfo({ form }) {
  const [cellRender] = useCellRender();
  const client = form.values;
  const dataFontWeight = 600;
  const { t } = useTranslation();
  const emptyStr = "-";
  const clientType = client.type;

  const [api] = useServerApi();

  const [creditBalance, setCreditBalance] = useState(0);

  useEffect(() => {
    fetchCredit();
  }, [client]);

  const fetchCredit = async () => {
    try {
      if (!client || !client._id) return;
      const credit = await api.Client.getAvailableCredit(client._id);
      // console.log("credit", credit);
      setCreditBalance(credit.balance);
    } catch (error) {
      console.log(error);
    }
  };

  const fields =
    clientType === "INDIVIDUAL"
      ? [
          { title: "Code", value: client.code ?? emptyStr },
          { title: "Name", value: client.name ?? emptyStr },
          { title: "Status", value: t(client.status) ?? emptyStr },

          { title: "Client Type", value: t(client.type) ?? emptyStr },
          { title: "Chinese Name", value: client.cname ?? emptyStr },
          { title: "Gender", value: t(client.gender) ?? emptyStr },
          { title: "ID Type", value: t(client.idType) ?? emptyStr },
          { title: "ID No.", value: client.id ?? emptyStr },
          {
            title: "ID Issue Country",
            value: t(client.idIssueCountry) ?? emptyStr,
          },
          {
            title: "ID Expiry",
            value:
              client.idType === "HKID"
                ? emptyStr
                : cellRender.Date(client.idDocExpiryDate, "YYYY-MM-DD") ??
                  emptyStr,
          },

          {
            title: "Date of Birth",
            value: cellRender.Date(client.birthday, "YYYY-MM-DD") ?? emptyStr,
          },
          {
            title: "Place of Birth",
            value: t(client.placeOfBirth) ?? emptyStr,
          },
          { title: "Nationality", value: t(client.nationality) ?? emptyStr },

          {
            title: "Marital Status",
            value: t(client.maritalStatus) ?? emptyStr,
          },
          { title: "Education", value: t(client.educationLevel) ?? emptyStr },
          { title: "Year Salary", value: client.yearlySalary ?? emptyStr },

          {
            title: "Professional Investor",
            value: client.professionalInvestor ? (
              <Badge size="sm" color="yellow" radius="sm">
                Yes
              </Badge>
            ) : (
              emptyStr
            ),
          },

          {
            title: "Created At",
            value: cellRender.Date(
              client.createdAt,
              "YYYY-MM-DD",
              dataFontWeight
            ),
          },
          {
            title: "Account Close Date",
            value:
              cellRender.Date(client.accountCloseDate, "YYYY-MM-DD") ?? emptyStr,
          },

          {
            title: "Available Credit",
            value: cellRender.Currency(creditBalance) ?? emptyStr,
          },
        ]
      : [
          { title: "Code", value: client.code ?? emptyStr },
          { title: "Name", value: client.name ?? emptyStr },
          { title: "Status", value: t(client.status) ?? emptyStr },

          { title: "Client Type", value: t(client.type) ?? emptyStr },
          { title: "Chinese Name", value: client.cname ?? emptyStr },
          {
            title: "Parent Company",
            value: client.parentCompany?.name ?? emptyStr,
          },
          {
            title: "Professional Investor",
            value: client.professionalInvestor ? (
              <Badge size="sm" color="yellow" radius="sm">
                Yes
              </Badge>
            ) : (
              emptyStr
            ),
          },
          {
            title: "Created At",
            value: cellRender.Date(
              client.createdAt,
              "YYYY-MM-DD",
              dataFontWeight
            ),
          },
          {
            title: "Account Close Date",
            value:
              cellRender.Date(client.accountCloseDate, "YYYY-MM-DD") ?? emptyStr,
          },
          {
            title: "Available Credit",
            value: cellRender.Currency(creditBalance) ?? emptyStr,
          },
        ];
  const otherIds = client.otherIds ?? [];

  return (
    <>
      <InfoGridList fields={fields} values={client} />
      {clientType === "INDIVIDUAL" && otherIds.length > 0 && (
        <>
          <Title order={6} mt="md" mb="xs">
            {t("Other IDs")}
          </Title>
          <Table fontSize="xs" striped withBorder>
            <thead>
              <tr>
                <th>{t("Type")}</th>
                <th>{t("ID No.")}</th>
                <th>{t("Issue Country")}</th>
                <th>{t("Expiry")}</th>
              </tr>
            </thead>
            <tbody>
              {otherIds.map((row, index) => (
                <tr key={index}>
                  <td>{t(row.idType) ?? emptyStr}</td>
                  <td>{row.id ?? emptyStr}</td>
                  <td>{t(row.idIssueCountry) ?? emptyStr}</td>
                  <td>
                    {row.idType === "HKID"
                      ? emptyStr
                      : cellRender.Date(row.idDocExpiryDate, "YYYY-MM-DD") ??
                        emptyStr}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}
    </>
  );
}
